import React, { Component } from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List,
    ListItemButton,
    ListItemIcon
} from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import i18n from '../../i18n';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

class TableSettingsDialog extends Component {
    //props: {open: boolean, onClose: function, Head: array, Name: string, onSave: function}
    constructor(props) {
        super(props);
        this.state = {
            head: this.props.Head,
            selectAll: this.isSelectedAll(this.props.Head)
        };
    }
    handleTableSettings = (id) => {
        let head = this.state.head;
        head.map((column) => {
            if (column.id === id) {
                column.displayGrid = !column.displayGrid;
            }
            return column;
        });
        this.setState({ head: head, selectAll: this.isSelectedAll(head) });
    };
    handleSelectAll = () => {
        const { head, selectAll } = this.state;
        const updatedHead = head.map((column) => ({
            ...column,
            displayGrid: !selectAll
        }));
        this.setState({ head: updatedHead, selectAll: !selectAll });
    };
    isSelectedAll = (head) => {
        return head.every((column) => column.displayGrid);
    };
    handleSave = () => {
        const merged = mergeHeadWithStorage(this.props.Name, this.props.Head);

        const userById = new Map((this.state.head || []).map((c) => [c.id, c]));
        const finalHead = (merged || []).map((col) => {
            const u = userById.get(col.id);
            if (u && typeof u.displayGrid === 'boolean') {
                return { ...col, displayGrid: u.displayGrid };
            }
            return col;
        });

        localStorage.setItem(
            `head_${this.props.Name}`,
            JSON.stringify(finalHead)
        );
        this.props.onSave();
    };
    render() {
        return (
            <Dialog open={this.props.open}>
                <DialogTitle>{i18n.t('common.tableSettings')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18n.t('text.tableSettingsDescription')}
                    </DialogContentText>
                    <List>
                        <ListItemButton
                            dense
                            onClick={this.handleSelectAll}
                            sx={{ mb: 3 }}
                        >
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={this.state.selectAll}
                                    color={
                                        this.state.selectAll
                                            ? 'success'
                                            : 'default'
                                    }
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'selectAll'
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="selectAll"
                                primary={i18n.t('common.selectAll')}
                            />
                        </ListItemButton>
                        {this.state.head.map((column) => (
                            <ListItemButton
                                key={column.id}
                                dense
                                onClick={() =>
                                    this.handleTableSettings(column.id)
                                }
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={!!column.displayGrid}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{
                                            'aria-labelledby': column.id
                                        }}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    id={column.id}
                                    primary={i18n.t(`columns.${column.label}`)}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose}>Cancel</Button>
                    <Button onClick={this.handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default TableSettingsDialog;
